import React, { useState } from 'react';

const AdditionalInfo = ({ shiftWorkReady, legalIssues, setShiftWorkReady, setLegalIssues }) => {
  const handleShiftModeChange = (e) => {
    if (e.target.value === 'Да') {
      setShiftWorkReady(true);
    } else {
      setShiftWorkReady(false);
    }
  }
  const handleProsecutionChange = (e) => {
    if (e.target.value === 'Да') {
      setLegalIssues(true);
    } else {
      setLegalIssues(false);
    }
  }
  return (
    <div className='profile-content'>
      <table style={{ marginTop: '-1px' }}>
        <tbody>
          <tr>
            <th colSpan="2">
              <p className="center b">Дополнительные сведения</p>
            </th>
          </tr>
          <tr>
            <td width="70%"><p className="b">Готовность к ваховому режиму работы?</p></td>
            <td width="30%">
              <select value={shiftWorkReady ? 'Да' : 'Нет'} onChange={handleShiftModeChange}>
                <option value="Да">Да</option>
                <option value="Нет">Нет</option>
              </select>
            </td>
          </tr>
          <tr>
            <td><p className="b">Привлекались ли Вы к административной или уголовной ответственности?</p></td>
            <td>
              <select value={legalIssues ? 'Да' : 'Нет'} onChange={handleProsecutionChange}>
                <option value="Да">Да</option>
                <option value="Нет">Нет</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AdditionalInfo;
